import { styled } from "styled-components";

//닉네임
export const NoReviews = styled.div`
  width: 100%;
  height: 100%;
  padding: 40px;
  font-size: 24px;
  font-weight: 600;
  border: 2px solid black;
`;
